import i18n from '@/locales'
import { useToastStore } from '@/stores/use-toast-store'
import { useErrorMessageListStore } from '@library/stores/use-error-message-list-store'
import { RtnCode } from '~library/enums'
import type { ApiRequestHeaders, ApiResponse } from '~library/services'

/** 統一處理 API 錯誤訊息的 Toast 顯示 */
export function useGlobalMessage() {
  const { t } = i18n.global

  /** 顯示 API 錯誤訊息 */
  const showApiErrorMessage = (response: ApiResponse) => {
    const { showToast } = useToastStore()
    const { formatErrorMessage } = useErrorMessageListStore()

    const { data, config } = response
    const { disableAlert, ignoreRtnCodeError } =
      config.headers as ApiRequestHeaders

    if (
      disableAlert ||
      // 如果 rtnCode 包含在 Axios 攔截器要忽略錯誤的 RtnCode 列表中，不顯示錯誤提示
      ignoreRtnCodeError?.includes(data.rtnCode?.toString() as `${RtnCode}`)
    ) {
      return
    }

    console.error('API 錯誤')
    console.error(response)

    if (response.data.rtnCode) {
      showToast({
        type: 'warn',
        iconName: 'Warning',
        title:
          formatErrorMessage({
            rtnCode: response.data.rtnCode,
            data: response.data.data
          }) || t('Composables.UseGlobalMessage.SystemError'),
        // 以 rtnCode 作為 toast id，確保同一錯誤不因連續 API 失敗而重複彈出
        id:
          response.data.rtnCode === RtnCode.ACCESS_PERMISSIONS_MODIFIED ||
          response.data.rtnCode === RtnCode.LATCHKEY_CHANGED
            ? response.data.rtnCode
            : undefined
      })
    } else {
      showToast({
        type: 'warn',
        iconName: 'Warning',
        title: t('Composables.UseGlobalMessage.SystemError')
      })
    }
  }

  return {
    /** 顯示 API 錯誤訊息 */
    showApiErrorMessage
  }
}
